'use client';

import Link from 'next/link';
import PricingTable from '@/components/PricingTable';

export default function PricingPage() {
  return (
    <div style={{ background: '#060B14', minHeight: '100vh' }}>
      <PricingTable showHero={true} />

      {/* ── Bottom CTA ── */}
      <section
        style={{
          background: 'rgba(255,255,255,0.01)',
          borderTop: '1px solid rgba(255,255,255,0.04)',
          padding: '88px 40px',
          textAlign: 'center',
        }}
      >
        <div style={{ maxWidth: '600px', margin: '0 auto' }}>
          <h2
            style={{
              fontSize: 'clamp(28px, 3.5vw, 42px)',
              fontWeight: 900,
              letterSpacing: '-0.03em',
              color: 'white',
              lineHeight: 1.1,
              marginBottom: '16px',
            }}
          >
            Start your free trial today
          </h2>
          <p style={{ fontSize: '16px', color: '#94A3B8', lineHeight: 1.65, marginBottom: '36px' }}>
            7 days free. No credit card required. Cancel anytime.
          </p>
          <Link
            href="/start"
            style={{
              display: 'inline-block',
              background: 'linear-gradient(135deg, #F97316, #EA580C)',
              color: 'white',
              padding: '15px 44px',
              borderRadius: '12px',
              fontSize: '15px',
              fontWeight: 700,
              textDecoration: 'none',
              boxShadow: '0 0 40px rgba(249,115,22,0.28)',
              transition: 'all 0.2s ease',
            }}
          >
            Start Your 7-Day Free Trial
          </Link>
          <p style={{ fontSize: '12px', color: '#475569', marginTop: '16px' }}>
            No credit card required · Cancel anytime · Setup in under 5 minutes
          </p>
        </div>
      </section>
    </div>
  );
}
